export default {"src":"/_next/static/media/telegram-icon.fe43ade2.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};